import Storage from '../lib/storage';
import { prepareData, displayStatusMessage } from '../helpers/notes-and-favorites';
import removeClassByPrefix from '../helpers/remove-classname-by-prefix';
import { setPopoutDirection } from './popout-menu';
import { IS_ACTIVE, FAVORITE_REMOVED, IS_DISABLED, IS_VISIBLE, POPOUT_TIMEOUT, ANIMATION } from '../constants';

const removeFavorite = (state: string, element: HTMLDivElement): void => {
    const parent: HTMLDivElement | null = element.closest('.wio__item');

    if (state === FAVORITE_REMOVED) {
        parent?.classList.add(ANIMATION.FADE_OUT);
        parent?.addEventListener('animationend', () => {
            parent.remove();
        });
    }
};

const activeFavoriteLink = (state: string, link: HTMLAnchorElement, allLinks: NodeListOf<HTMLAnchorElement>, element: HTMLDivElement): void => {
    allLinks.forEach((elm: HTMLAnchorElement) => {
        elm.classList.remove(IS_ACTIVE);
    });
    link.classList.add(IS_ACTIVE);

    removeClassByPrefix(element, `state-`);
    element.classList.add(`state-${state}`);
};

const attachFavoriteEvents = (addFavElements: NodeListOf<HTMLDivElement>, storage: Storage, isShowFavoritesAfterLogin: boolean): void => {
    addFavElements.forEach((element: HTMLDivElement) => {
        const favChoices: HTMLDivElement | null = element.querySelector('.add-favorite__choice');
        const chathostNick: string | null = element.getAttribute('data-name');

        if (isShowFavoritesAfterLogin && favChoices) {
            element.classList.add(IS_ACTIVE);
            favChoices.classList.add(IS_VISIBLE);
            setPopoutDirection(favChoices);

            hideWithDelayOnClick(element, favChoices);
            storage.delete('showFavoritesAfterLogin');

            Analytics.sendEvent({
                category: 'Profile',
                action: 'Favorites',
                label: 'Guest logged in',
            });
        }

        const favActionLinks: NodeListOf<HTMLAnchorElement> = element.querySelectorAll('a');

        favActionLinks.forEach((link: HTMLAnchorElement) => {
            const chathostID: string | undefined = link.dataset.id;
            const action: string | undefined = link.dataset.action;
            const state: string | undefined = link.dataset.state;

            if (chathostID && action && state && chathostNick) {
                link.addEventListener('click', async (e: Event) => {
                    e.preventDefault();

                    element.classList.add(IS_DISABLED);

                    const requestStatus: boolean = await prepareData(chathostID, action, { state: state });

                    if (requestStatus) {
                        activeFavoriteLink(state, link, favActionLinks, element);
                        removeFavorite(state, element);
                        displayStatusMessage({
                            chathost: chathostNick,
                            action: action,
                            state: state,
                            status: requestStatus,
                        });

                        element.classList.remove(IS_DISABLED);
                    }
                });
            }
        });
    });
};

const hideWithDelayOnClick = (selector: HTMLDivElement, subnav: HTMLDivElement): void => {
    let timeout: ReturnType<typeof setTimeout>;

    const handler = () => {
        timeout = setTimeout(() => {
            selector.classList.remove(IS_ACTIVE);
            subnav.classList.remove(IS_VISIBLE);
        }, POPOUT_TIMEOUT);
        document.removeEventListener('click', handler);
    };
    document.addEventListener('click', handler);
};

const attachEvents = (): void => {
    const storage: Storage = new Storage('favorites');
    const isShowFavoritesAfterLogin: boolean = storage.get('showFavoritesAfterLogin');
    const addFavoriteNotLoggedIn: HTMLDivElement | null = document.querySelector('.js-add-favorite-set');

    addFavoriteNotLoggedIn?.addEventListener('click', () => {
        storage.set('showFavoritesAfterLogin', true);
    });

    const addFavElements: NodeListOf<HTMLDivElement> = document.querySelectorAll('.js-add-favorite');
    attachFavoriteEvents(addFavElements, storage, isShowFavoritesAfterLogin);
};

attachEvents();
